export default "__VITE_ASSET__DOGFG7Ec__"